import Text from '@cartwhl/ui/base/Text';

export default function OrientationInfo({
  className,
  mobileVariant = 'expand',
}: {
  className?: string;
  mobileVariant?: 'collapse' | 'expand';
  layout?: 'row' | 'column';
}) {
  const isExpanded = mobileVariant === 'expand';

  const getItemSpan = () => {
    if (isExpanded) return 'col-span-1';
    return 'col-span-2 sm:col-span-1';
  };

  const borderClasses = isExpanded
    ? 'border-t pt-6 pb-2'
    : 'sm:border-t sm:pt-6 sm:pb-2';

  return (
    <div
      className={`border-gray-30 dark:border-gray-75 flex flex-col gap-3 ${borderClasses} ${className}`}
    >
      <div className="grid grid-cols-2 sm:grid-cols-3 sm:gap-x-4 sm:gap-y-6">
        <Text
          variant="studio/body/medium/sm"
          className="col-span-2 mb-3 sm:col-span-1 sm:mb-0"
        >
          Orientation
        </Text>

        <div className={`flex items-center gap-2 ${getItemSpan()}`}>
          <Text className="text-gray-60" variant="studio/body/sm">
            Forward:
          </Text>
          <Text className="text-gray-60" variant="studio/body/sm">
            -Z Forward
          </Text>
        </div>

        <div className={`flex items-center gap-2 ${getItemSpan()}`}>
          <Text className="text-gray-60" variant="studio/body/sm">
            Up:
          </Text>
          <Text className="text-gray-60" variant="studio/body/sm">
            Y Up
          </Text>
        </div>
      </div>
    </div>
  );
}
